import slide from '~/components/molecules/m-slide/m-slide-v2.data'
import cta from '~/components/atoms/a-ctas/a-cta-v2.data'
export default {
  slide_autoplay: true,
  nav: [
    {
      copy_previous: 'Previous',
      copy_next: 'Next',
      copy_of: null,
      component: 'm-carousel-nav',
    },
  ],
  slides: [
    {
      ...slide,
      eyebrow: null,
      heading: 'The Future of Consumer Behaviour.',
      copy: 'For the final webinar in our ‘Covid-19 Now, The Future and The New Normal’ Total Experiences series, we discussed the future of consumer behaviour.',
      image: {
        alt: 'Article Image',
        filename:
          '//a.storyblok.com/f/46530/1500x1000/7fe5d7c38b/kyle-glenn-nxt5htlmlge-unsplash.jpg',
      },
      cta: [
        {
          ...cta,
          copy: 'See the project',
          href: {
            url: '/case-study',
            cached_url: '/case-study',
          },
          type: 'secondary',
        },
      ],
    },
    {
      ...slide,
      eyebrow: null,
      heading: 'Alice Wainwright named in 2020 BIMA 100',
      copy: 'She has been named as one of eight digital changemakers in the Client Services and Project Management category, which recognises the individuals who have led new and different ways of working with clients to deliver profitable growth.',
      image: {
        alt: 'Article Image',
        filename:
          '//a.storyblok.com/f/46530/1502x1001/13252f874d/jason-leung-xaanw0s0pmk-unsplash.jpg',
      },
      cta: [
        {
          ...cta,
          copy: 'See the project',
          href: {
            url: '/case-study',
            cached_url: '/case-study',
          },
          type: 'secondary',
        },
      ],
    },
    {
      ...slide,
      eyebrow: null,
      heading: 'Covid-19 and a New Agile',
      copy: 'David Balko, our Chief Client Officer at Tribal Worldwide London was joined by Linda Davidson, Head of Technology, Operations and Transformation at Essence this week for the next instalment of our Total Experience series ‘Covid-19 Now, The Future and The New Normal’.',
      image: {
        alt: 'Image showing the classic Volkswagen Campervan',
        filename:
          '//a.storyblok.com/f/46530/2501x1668/d5dafedba0/gabriel-benois-qnwpjzewewa-unsplash.jpg',
      },
      cta: [
        {
          ...cta,
          copy: 'See the project',
          href: {
            url: '/case-study',
            cached_url: '/case-study',
          },
          type: 'secondary',
        },
      ],
    },
  ],
}
